const publishForgeHausEvent = (name, data = {}) => {
  window.Shopify?.analytics?.publish?.(`forgehaus:${name}`, {
    pagePath: window.location.pathname,
    ...data,
  });
};

document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    const linkText = (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 120);

    if (href.startsWith('tel:')) {
      publishForgeHausEvent('phone_click', { linkText });
      return;
    }

    if (href.startsWith('mailto:')) {
      publishForgeHausEvent('email_click', { linkText });
      return;
    }

    if (/install|fitment/i.test(`${linkText} ${href}`)) {
      publishForgeHausEvent('installation_enquiry_click', { linkText });
    }
  },
  { capture: true }
);

document.addEventListener(
  'submit',
  (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;

    const action = event.target.getAttribute('action') || '';
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(action)) {
      const productVariantId = new FormData(event.target).get('id');
      publishForgeHausEvent('add_to_cart', productVariantId ? { productVariantId } : {});
      return;
    }

    if (!event.target.querySelector('[name="contact[email]"]')) return;

    publishForgeHausEvent('contact_submit');
  },
  { capture: true }
);

if (document.querySelector('.contact-form__success')) {
  publishForgeHausEvent('contact_submit_success');
}
